<template>
  <div class="headers">
    <div class="my_header">
      <div class="message" style="gap: 25px">
        <div class="tit_h2">
          <h2>账户信息</h2>
          <span
            v-if="
              msg_copy.is_bind_wx && msg_copy.sing_on && !msg_copy.is_perfect
            "
            @click="editUser"
          >
            微信绑定 <i class="el-icon-edit-outline"></i>
          </span>
        </div>
        <!--  -->
        <div
          style="
            display: flex;
            padding: 0px 24px;
            align-items: flex-start;
            gap: 100px;
            align-self: stretch;
          "
        >
          <img
            v-if="
              headshot &&
              headshot !==
                'https://thirdwx.qlogo.cn/mmopen/vi_32/POgEwh4mIHO4nibH0KlMECNjjGxQUq24ZEaGT4poC6icRiccVGKSyXwibcPq4BWmiaIGuG1icwxaQX6grC9VemZoJ8rg/132'
            "
            :src="headshot"
            alt=""
          />
          <img v-else src="../../../assets/imgs/2.2/user_2x_02.png" alt="" />
          <div class="meaasge_box">
            <div class="meaasge_box_grid">
            <div class="box_li">
              <div class="box_li_left">认证状态</div>
              <div
                class="box_li_right box_li_right--status"
              >
                <img
                  v-if="msg_copy.id_photo_state == 2 || !msg_copy.is_idphoto"
                  class="status-badge"
                  src="../../../assets/imgs/user/userFormal.png"
                  alt=""
                  draggable="false"
                />
                <img
                  v-else
                  class="status-badge"
                  src="../../../assets/imgs/user/userTria.png"
                  alt=""
                  draggable="false"
                  :style="
                    msg_copy.improve_rewards == '1' ? 'cursor: pointer;' : ''
                  "
                  @click="showAppDialog"
                />
                <span
                  v-if="msg_copy.improve_rewards == '1'"
                  class="textCer_css"
                  :style="
                    msg_copy.id_photo_state == 2 || !msg_copy.is_idphoto
                      ? 'color: #226CFF;'
                      : 'color: #fd6273;'
                  "
                  @click="showAppDialog"
                >
                  {{
                    msg_copy.id_photo_state == 2 || !msg_copy.is_idphoto
                      ? "查看认证权益"
                      : "立即认证"
                  }}
                  <i class="el-icon-arrow-right"></i>
                </span>
              </div>
            </div>
            <div class="box_li">
              <div class="box_li_left">所属机构</div>
              <div class="box_li_right box_li_right--status">
                {{ orgName ? orgName : "--" }}
                <img
                  v-if="msg_copy.organ_class == '试用'"
                  class="org-badge"
                  src="../../../assets/imgs/user/orgTrial.png"
                  alt=""
                  draggable="false"
                />
                <img
                  v-else
                  class="org-badge"
                  src="../../../assets/imgs/user/orgFormal.png"
                  alt=""
                  draggable="false"
                />
              </div>
            </div>
            <div class="box_li box_li--editable" @click="openProfileEdit('name')">
              <div class="box_li_left">姓名</div>
              <div class="box_li_right box_li_right--action">
                <span :class="{ 'contact-unbound': !name }">
                  {{ name || "未填写" }}
                </span>
                <span v-if="!name" class="contact-dot"></span>
                <i class="el-icon-arrow-right contact-arrow"></i>
              </div>
            </div>
            <div class="box_li box_li--editable" @click="openContactEdit('phone')">
              <div class="box_li_left">电话</div>
              <div class="box_li_right box_li_right--action">
                <span>{{ getDisplayPhone() }}</span>
                <i class="el-icon-arrow-right contact-arrow"></i>
              </div>
            </div>
            <div class="box_li">
              <div class="box_li_left">{{ getOrganLabel() }}</div>
              <div class="box_li_right box_li_right--action">
                <span :class="{ 'contact-unbound': !parentOrganName }">
                  {{ parentOrganName || "待完善" }}
                </span>
                <span v-if="!parentOrganName" class="contact-dot"></span>
              </div>
            </div>
            <div class="box_li box_li--editable" @click="openContactEdit('email')">
              <div class="box_li_left">邮箱</div>
              <div class="box_li_right box_li_right--action">
                <span
                  :class="{
                    'contact-unbound': !isEmailBound(),
                  }"
                >
                  {{ getDisplayEmail() }}
                </span>
                <span v-if="!isEmailBound()" class="contact-dot"></span>
                <i class="el-icon-arrow-right contact-arrow"></i>
              </div>
            </div>
            <div
              v-if="twoOr"
              class="box_li box_li--editable"
              @click="openProfileEdit('userorgan_name')"
            >
              <div class="box_li_left">{{ getDepartmentLabel() }}</div>
              <div class="box_li_right box_li_right--action">
                <span :class="{ 'contact-unbound': !userOrganName }">
                  {{ userOrganName || "待完善" }}
                </span>
                <span v-if="!userOrganName" class="contact-dot"></span>
                <i class="el-icon-arrow-right contact-arrow"></i>
              </div>
            </div>
            <div class="box_li box_li--editable" @click="openProfileEdit('group')">
              <div class="box_li_left">{{ getGroupLabel() }}</div>
              <div class="box_li_right box_li_right--action">
                <span :class="{ 'contact-unbound': !group }">
                  {{ group || "待完善" }}
                </span>
                <span v-if="!group" class="contact-dot"></span>
                <i class="el-icon-arrow-right contact-arrow"></i>
              </div>
            </div>
            </div>
            <!-- <div class="tag">
              <span class="name">{{ name }}</span>
              <el-tag
                effect="dark"
                class="accountType"
                v-if="
                  (msg_copy.id_photo && msg_copy.id_photo_state == 2) ||
                  !msg_copy.is_idphoto
                "
                >正式用户</el-tag
              >
              
              <el-tag effect="dark" type="warning" class="accountType" v-else
                >临时用户</el-tag
              >
              <span v-if="status == 2 || status == 4" @click="textmsg">
                <i
                  class="el-icon-question"
                  style="font-size: 20px; cursor: pointer"
                ></i>
              </span>
              <el-tag class="groupName" v-if="source_name !== ''"
                ><el-tooltip
                  class="item"
                  effect="dark"
                  :content="source_name"
                  placement="bottom"
                  ><span>{{ source_name }}</span></el-tooltip
                ></el-tag
              >
            </div>
            <div class="email">邮箱：{{ email_(email) }}</div>
            <div class="phone">电话：{{ phone }}</div> -->
          </div>
        </div>
      </div>
      <div class="message" style="gap: 15px">
        <h2>文献信息</h2>
        <!-- <div class="table_css">
          <div class="table_header_s">

          </div>
          <div class="table_th_s"></div>
          <div class="table_th_s"></div>
        </div> -->
        <el-table :data="tableData" stripe border class="literatureInfo">
          <el-table-column prop="type" align="center" label="类型">
            <template slot-scope="scope">
              <span class="table_type">
                {{ scope.row.type }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="中文书" align="center" label="中文书">
            <template slot-scope="scope">
              <span class="table_type">
                {{ scope.row["中文书"] }} 册
              </span></template
            >
          </el-table-column>
          <el-table-column prop="英文书" align="center" label="英文书">
            <template slot-scope="scope">
              <span class="table_type">
                {{ scope.row["英文书"] }} 册
              </span></template
            >
          </el-table-column>
          <el-table-column prop="中文文献" align="center" label="中文文献">
            <template slot-scope="scope">
              <span class="table_type">
                {{ scope.row["中文文献"] }} 篇
              </span></template
            >
          </el-table-column>
          <el-table-column prop="英文文献" align="center" label="英文文献">
            <template slot-scope="scope">
              <span class="table_type">
                {{ scope.row["英文文献"] }} 篇
              </span></template
            >
          </el-table-column>
          <el-table-column prop="其他" align="center" label="其他">
            <template slot-scope="scope">
              <span class="table_type">
                {{ scope.row["其他"] }} 篇
              </span></template
            >
          </el-table-column>
        </el-table>
      </div>
      <div class="message" style="gap: 15px">
        <h2>资源使用情况</h2>

        <el-table :data="useData" stripe border class="literatureInfo">
          <el-table-column prop="type" align="center" label="类型">
            <template slot-scope="scope">
              <span class="table_type">
                {{ scope.row.type }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(value, key, index) in useData[0]"
            :key="index"
            :prop="key"
            align="center"
            :label="key == 'type' ? '类型' : key"
            v-if="key !== 'type'"
          >
            <template slot-scope="scope">
              <span class="table_type">
                {{ scope.row[key] }}<span v-if="key == '图书/天'"> 册</span>
                <span v-else-if="key !== 'type'"> 篇</span>
              </span>
            </template>
          </el-table-column>
          <!-- 
          <el-table-column prop="图书/天" align="center" label="图书/天">
            <template slot-scope="scope">
              <span class="table_type">
                {{ scope.row["图书/天"] }} 册
              </span></template
            >
          </el-table-column>
          <el-table-column prop="文献/天" align="center" label="文献/天">
            <template slot-scope="scope">
              <span class="table_type">
                {{ scope.row["文献/天"] }} 篇
              </span></template
            >
          </el-table-column>
          <el-table-column prop="校对/年" align="center" label="校对/年">
            <template slot-scope="scope">
              <span class="table_type">
                {{ scope.row["校对/年"] }} 篇
              </span></template
            >
          </el-table-column>
          <el-table-column prop="查重/总量" align="center" label="查重/总量">
            <template slot-scope="scope">
              <span class="table_type">
                {{ scope.row["查重/总量"] }} 篇
              </span></template
            >
          </el-table-column>
          <el-table-column prop="翻译/总量" align="center" label="翻译/总量">
            <template slot-scope="scope">
              <span class="table_type">
                {{ scope.row["翻译/总量"] }} 篇
              </span></template
            >
          </el-table-column> -->
        </el-table>
      </div>
    </div>

    <el-dialog
      :title="editContactDialogTitle"
      :visible.sync="editContactVisible"
      width="520px"
      append-to-body
      :close-on-click-modal="false"
      custom-class="contact-edit-dialog"
      @closed="resetContactEdit"
    >
      <div v-if="editContactType === 'phone' && editContactStep === 1" class="contact-edit-step">
        <p class="contact-edit-desc">
          <span class="contact-edit-muted">当前手机号绑定为 </span>
          <span>+86 {{ getMaskedPhone() }}</span>
          <span class="contact-edit-muted">，请补全原手机号隐藏部分进行验证</span>
        </p>
        <div class="phone-verify-code-wrap" @click="focusPhoneVerifyInput">
          <div class="phone-verify-code-container">
            <div
              v-for="index in 4"
              :key="'phone-verify-' + index"
              class="phone-verify-code-box"
              :class="{ 'is-active': isPhoneVerifyBoxActive(index - 1) }"
              @click.stop="focusPhoneVerifyInput"
            >
              {{ editPhoneVerify[index - 1] || "" }}
            </div>
          </div>
          <input
            ref="phoneVerifyInput"
            :value="editPhoneVerify"
            type="tel"
            inputmode="numeric"
            maxlength="4"
            class="phone-verify-hidden-input"
            @input="onPhoneVerifyInput"
            @focus="editPhoneVerifyFocus = true"
            @blur="editPhoneVerifyFocus = false"
          />
        </div>
      </div>

      <div v-else class="contact-edit-step">
        <p class="contact-edit-desc">
          {{ editContactStepDesc }}
        </p>
        <el-form label-width="0" @submit.native.prevent>
          <el-form-item class="profile-edit-field">
            <el-input
              v-model="editNewVal"
              :placeholder="editContactType === 'phone' ? '请输入新的手机号' : '请输入新的邮箱地址'"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item class="profile-edit-field profile-edit-field--code">
            <div class="contact-code-row">
              <el-input
                v-model="editCodeVal"
                placeholder="请输入验证码"
                maxlength="6"
                class="contact-code-input"
                @keyup.enter.native="submitContactEdit"
              ></el-input>
              <el-button
                type="primary"
                class="contact-code-btn"
                :disabled="editCountdown > 0 || editSendingCode"
                @click="sendContactCode"
              >
                {{ editCountdown > 0 ? `${editCountdown}s` : "获取验证码" }}
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="profile-edit-footer">
        <button
          type="button"
          class="profile-edit-btn profile-edit-btn--cancel"
          @click="editContactVisible = false"
        >
          取消
        </button>
        <button
          v-if="editContactType === 'phone' && editContactStep === 1"
          type="button"
          class="profile-edit-btn profile-edit-btn--confirm"
          @click="verifyPhoneStep"
        >
          下一步
        </button>
        <button
          v-else
          type="button"
          class="profile-edit-btn profile-edit-btn--confirm"
          :disabled="editSubmitting"
          @click="submitContactEdit"
        >
          完成绑定
        </button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="editProfileVisible"
      width="480px"
      append-to-body
      :close-on-click-modal="false"
      custom-class="profile-edit-dialog"
      @closed="resetProfileEdit"
      @opened="onProfileDialogOpened"
    >
      <div class="profile-edit-box">
        <div class="profile-edit-title">{{ editProfileLabel }}</div>
        <el-form label-width="0" class="profile-edit-form" @submit.native.prevent>
          <el-form-item v-if="editProfileType !== 'userorgan_name'" class="profile-edit-field">
            <el-input
              ref="profileEditInput"
              v-model="editProfileVal"
              placeholder="请输入"
              clearable
              @keyup.enter.native="submitProfileEdit"
            ></el-input>
          </el-form-item>
          <template v-else>
            <el-form-item class="profile-edit-field">
              <el-select
                v-model="editOrganSelect"
                placeholder="请选择"
                filterable
                @change="onOrganSelectChange"
              >
                <el-option
                  v-for="item in organColumns"
                  :key="item.organ_name"
                  :label="item.organ_name"
                  :value="item.organ_name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="editOrganCustomMode" class="profile-edit-field">
              <el-input
                ref="profileEditInput"
                v-model="editOrganCustom"
                placeholder="请输入"
                clearable
                @keyup.enter.native="submitProfileEdit"
              ></el-input>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <div slot="footer" class="profile-edit-footer">
        <button
          type="button"
          class="profile-edit-btn profile-edit-btn--cancel"
          @click="editProfileVisible = false"
        >
          取消
        </button>
        <button
          type="button"
          class="profile-edit-btn profile-edit-btn--confirm"
          :disabled="editProfileSubmitting"
          @click="submitProfileEdit"
        >
          保存
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import bus from "@/utils/eventBus";
import {
  personalMessage,
  wenNumber,
  emailRegister,
  modifyUserSendCode,
  modifyUser,
  userorganInfo,
  serachDepartment,
} from "@/Api/userMessage";
export default {
  data() {
    return {
      name: "",
      id_photo: false,
      source_name: "",
      email: "",
      phone: "",
      tableData: [],
      useData: [],
      headshot: "",
      status: localStorage.getItem("status"),
      msg_copy: {
        sing_on: false,
        is_perfect: false,
      },
      path_: "",
      keys_: "",
      orgName: "",
      userCode: "",
      real_phone: "",
      industry: "",
      organParentCode: "",
      organId: "",
      parentOrganName: "",
      userOrganName: "",
      group: "",
      twoOr: false,
      organColumns: [],
      editProfileVisible: false,
      editProfileType: "name",
      editProfileLabel: "",
      editProfileVal: "",
      editOrganSelect: "",
      editOrganCustom: "",
      editOrganCustomMode: false,
      editProfileSubmitting: false,
      editContactVisible: false,
      editContactType: "phone",
      editContactStep: 1,
      editNewVal: "",
      editCodeVal: "",
      editPhoneVerify: "",
      editPhoneVerifyFocus: false,
      editCountdown: 0,
      editCountdownTimer: null,
      editSendingCode: false,
      editSubmitting: false,
    };
  },
  created() {
    // this.created_fun()
    this.created_fun();
  },
  watch: {
    editContactVisible(val) {
      if (
        val &&
        this.editContactType === "phone" &&
        this.editContactStep === 1
      ) {
        this.$nextTick(() => {
          this.focusPhoneVerifyInput();
        });
      }
    },
    $route(to, from) {
      if (to.query.webPage) {
        // console.log("to.query.webPage",to, to.query.webPage);
        if (to.name == "Personal" && to.query.webPage == "1") {
          this.created_fun();
        }
      }
    },
  },
  mounted() {},
  beforeDestroy() {
    this.clearEditCountdown();
  },
  computed: {
    editContactDialogTitle() {
      if (this.editContactType === "phone" && this.editContactStep === 1) {
        return "验证原手机号";
      }
      if (this.editContactType === "phone") {
        return this.getMaskedPhone() ? "绑定新手机号" : "绑定手机号";
      }
      return this.isEmailBound() ? "绑定新邮箱" : "绑定邮箱";
    },
    editContactStepDesc() {
      if (this.editContactType === "phone") {
        return this.getMaskedPhone()
          ? "请输入新的手机号并完成验证码校验"
          : "请输入手机号并完成验证码校验";
      }
      return this.isEmailBound()
        ? "请输入新的邮箱地址并完成验证码校验"
        : "请输入邮箱地址并完成验证码校验";
    },
  },
  methods: {
    showAppDialog() {
      // console.log('aaa')
      bus.$emit("open-app-dialog");
    },
    created_fun() {
      if (this.$route.path) {
        this.path_ = this.$route.path;
      }
      if (this.$route.query.webPage) {
        this.keys_ = this.$route.query.webPage.toString();
      }
      console.log(this.path_, this.keys_);
      if (sessionStorage.getItem("headshot")) {
        this.headshot = sessionStorage.getItem("headshot");
      }
      if (sessionStorage.getItem("mes")) {
        let mes_ = JSON.parse(sessionStorage.getItem("mes"));
        this.name = mes_.name;
        this.id_photo = mes_.id_photo;
        this.source_name = mes_.belong_name;
        this.email = mes_.email;
        this.phone = mes_.phone;
        this.headshot = mes_.avatarUrl;
        this.orgName = mes_.org_name;
        this.userCode = mes_.code || localStorage.getItem("code") || "";
        this.real_phone = mes_.real_phone || "";
        this.applyUserProfileFields(mes_);
        sessionStorage.setItem("headshot", mes_.avatarUrl);
        sessionStorage.setItem("unionid", mes_.unionid);
        this.msg_copy = mes_;

        if (
          this.msg_copy.sing_on &&
          this.msg_copy.is_perfect &&
          this.path_ == "/personal" &&
          this.keys_ == "1"
        ) {
          this.$bus.$emit("callFunction", this.msg_copy);
        }
        this.getAgeCount();
      } else {
        this.message();
      }
    },
    textmsg() {
      // 判断status
      if (this.status == 2) {
        this.$message({
          message:
            "您当前的账号状态，为了更精确的确认您的身份信息，请您完善您的个人信息与证件",
          type: "warning",
        });
      } else if (this.status == 4) {
        this.$message({
          message: "账号审核未通过，账号信息不符合规则，您可以修改账号信息",
          type: "warning",
        });
      }
    },
    message() {
      personalMessage()
        .then((res) => {
          console.log(res);
          this.name = res.data.data.name;
          this.id_photo = res.data.data.id_photo;
          this.source_name = res.data.data.belong_name;
          this.email = res.data.data.email;
          this.phone = res.data.data.phone;
          this.orgName = res.data.data.org_name;
          this.userCode = res.data.data.code || localStorage.getItem("code") || "";
          this.real_phone = res.data.data.real_phone || "";
          this.headshot = res.data.data.avatarUrl;
          this.msg_copy = res.data.data;
          this.applyUserProfileFields(res.data.data);
          sessionStorage.setItem("headshot", res.data.data.avatarUrl);
          sessionStorage.setItem("unionid", res.data.data.unionid);
          if (
            this.msg_copy.sing_on &&
            this.msg_copy.is_perfect &&
            this.path_ == "/personal" &&
            this.keys_ == "1"
          ) {
            this.$bus.$emit("callFunction", this.msg_copy);
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.getAgeCount();
    },
    getAgeCount() {
      wenNumber()
        .then((res) => {
          let settingObj = res.data.data;
          let settingArr = Object.keys(settingObj).map((key) => {
            if (key == "year") {
              settingObj["year"].type = "本月";
            } else if (key == "day") {
              settingObj["day"].type = "本日";
            } else if (key == "remaining") {
              settingObj["remaining"].type = "剩余";
            } else if (key == "total") {
              settingObj["total"].type = "总量";
            }
            return settingObj[key];
            //把每个对象返回出去生成一个新的数组中相当于0:{id:1}
          });
          // console.log(JSON.stringify(settingArr))
          const filteredData = settingArr.filter(
            (item) => item.type === "本月" || item.type === "本日"
          );

          // console.log(filteredData);
          this.tableData = filteredData;
          const filteredData_ = settingArr.filter(
            (item) => item.type === "剩余" || item.type === "总量"
          );
          this.useData = filteredData_;
          // console.log("aaaa", JSON.stringify(this.useData));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    editUser() {
      let mes_ = JSON.parse(sessionStorage.getItem("mes"));
      this.msg_copy = mes_;
      this.$bus.$emit("callFunction", this.msg_copy);
    },
    email_(email) {
      let reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!reg.test(email)) {
        return "";
      } else {
        return email;
      }
    },
    isEmailBound() {
      const boundEmail = this.email_(this.email);
      return !!(boundEmail && boundEmail !== this.userCode);
    },
    getDisplayEmail() {
      return this.isEmailBound() ? this.email_(this.email) : "未绑定";
    },
    getMaskedPhone() {
      if (!this.phone) return "";
      return String(this.phone).replace(/xxxx/gi, "****");
    },
    getDisplayPhone() {
      const maskedPhone = this.getMaskedPhone();
      return maskedPhone ? `+86 ${maskedPhone}` : "--";
    },
    normalizeIndustry(industry) {
      const universityIndustries = [
        "本科",
        "本科学院",
        "本科实验室",
        "本科研究院",
        "军校",
        "警校",
        "高职",
        "党校",
        "国际学校",
        "基础教育",
        "中专",
        "团校",
      ];
      const hospitalIndustries = ["医院", "医院科室", "研究院"];
      if (universityIndustries.includes(industry)) {
        return "高校";
      }
      if (hospitalIndustries.includes(industry)) {
        return "医院";
      }
      return industry || "";
    },
    applyUserProfileFields(data) {
      this.industry = this.normalizeIndustry(data.industry);
      this.organParentCode = data.organ_parent_code || data.org_code || "";
      this.organId = data.organ_id || "";
      this.parentOrganName =
        data.parent_organ_name || data.org_name || this.orgName || "";
      this.userOrganName = this.resolveUserOrganName(data);
      this.group = this.resolveProfileText(data.group, data.code);
      this.fetchOrganOptions(this.organParentCode, this.organId);
    },
    resolveProfileText(value, code) {
      const text = String(value || "").trim();
      const placeholder = code || this.userCode || "";
      return text && text !== placeholder ? text : "";
    },
    resolveUserOrganName(data) {
      const code = (data && data.code) || this.userCode || "";
      const pick = (val) => {
        const text = String(val || "").trim();
        return text && text !== code ? text : "";
      };
      return pick(data.userorgan_name) || pick(data.faculty);
    },
    normalizeOrganList(list) {
      if (!Array.isArray(list)) {
        return [];
      }
      return list.map((item) => {
        if (typeof item === "string") {
          return { organ_name: item };
        }
        return item;
      });
    },
    extractOrganInfoOptions(res) {
      const body = (res && res.data) || {};
      const inner = body.data;
      if (inner && !Array.isArray(inner) && Array.isArray(inner.data)) {
        return {
          list: this.normalizeOrganList(inner.data),
          isCustomize: !!inner.is_customize,
        };
      }
      if (Array.isArray(inner)) {
        return {
          list: this.normalizeOrganList(inner),
          isCustomize: !!body.is_customize,
        };
      }
      return { list: [], isCustomize: true };
    },
    extractDepartmentOptions(res) {
      const data = (res && res.data && res.data.data) || {};
      const list = Array.isArray(data.organ_name_list) ? data.organ_name_list : [];
      return {
        list: this.normalizeOrganList(list),
        isCustomize: !!data.is_customize,
      };
    },
    applyOrganOptions({ list, isCustomize }) {
      const columns = [...list];
      if (!isCustomize) {
        const hasCustom = columns.some((item) => item.organ_name === "自定义");
        if (!hasCustom) {
          columns.push({ organ_name: "自定义" });
        }
      }
      this.organColumns = columns;
      this.twoOr = columns.length > 0;
    },
    fetchOrganOptions(organCode, organId) {
      const parentCode = organCode || this.organParentCode;
      const orgId = organId || this.organId;
      if (!parentCode && !orgId) {
        this.twoOr = false;
        this.organColumns = [];
        return Promise.resolve(false);
      }
      const loadByOrganCode = parentCode
        ? userorganInfo({ organ_code: parentCode }).then((res) =>
            this.extractOrganInfoOptions(res)
          )
        : Promise.resolve(null);
      return loadByOrganCode
        .then((result) => {
          if (result && result.list.length > 0) {
            this.applyOrganOptions(result);
            return true;
          }
          if (!orgId) {
            this.twoOr = false;
            this.organColumns = [];
            return false;
          }
          return serachDepartment({
            org_id: orgId,
            con: "",
          })
            .then((res) => {
              const fallback = this.extractDepartmentOptions(res);
              if (fallback.list.length > 0) {
                this.applyOrganOptions(fallback);
                return true;
              }
              this.twoOr = false;
              this.organColumns = [];
              return false;
            })
            .catch((err) => {
              console.log(err);
              this.twoOr = false;
              this.organColumns = [];
              return false;
            });
        })
        .catch((err) => {
          console.log(err);
          if (!orgId) {
            this.twoOr = false;
            this.organColumns = [];
            return false;
          }
          return serachDepartment({
            org_id: orgId,
            con: "",
          })
            .then((res) => {
              const fallback = this.extractDepartmentOptions(res);
              if (fallback.list.length > 0) {
                this.applyOrganOptions(fallback);
                return true;
              }
              this.twoOr = false;
              this.organColumns = [];
              return false;
            })
            .catch((innerErr) => {
              console.log(innerErr);
              this.twoOr = false;
              this.organColumns = [];
              return false;
            });
        });
    },
    prepareOrganEditState() {
      const currentVal = this.userOrganName || "";
      const hasTarget = this.organColumns.some(
        (item) => item.organ_name === currentVal
      );
      if (!hasTarget && currentVal) {
        this.editOrganSelect = "自定义";
        this.editOrganCustom = currentVal;
        this.editOrganCustomMode = true;
      } else {
        this.editOrganSelect = currentVal;
        this.editOrganCustom = "";
        this.editOrganCustomMode = false;
      }
      this.editProfileVal = "";
    },
    getOrganLabel() {
      return this.industry === "高校" ? "学校名称" : "单位名称";
    },
    getDepartmentLabel() {
      if (this.industry === "高校") {
        return "院系";
      }
      return this.industry === "医院" ? "科室" : "部门";
    },
    getGroupLabel() {
      return this.industry === "高校" ? "专业" : "团队";
    },
    openProfileEdit(type) {
      if (type === "userorgan_name" && !this.organColumns.length) {
        this.fetchOrganOptions().then((ok) => {
          if (!ok) {
            this.$message.warning(`暂无可选${this.getDepartmentLabel()}`);
            return;
          }
          this.showProfileEditDialog(type);
        });
        return;
      }
      if (type === "userorgan_name" && !this.twoOr) {
        this.$message.warning(`暂无可选${this.getDepartmentLabel()}`);
        return;
      }
      this.showProfileEditDialog(type);
    },
    showProfileEditDialog(type) {
      this.editProfileType = type;
      if (type === "name") {
        this.editProfileLabel = "姓名";
        this.editProfileVal = this.name || "";
        this.editOrganSelect = "";
        this.editOrganCustom = "";
        this.editOrganCustomMode = false;
      } else if (type === "group") {
        this.editProfileLabel = this.getGroupLabel();
        this.editProfileVal = this.group || "";
        this.editOrganSelect = "";
        this.editOrganCustom = "";
        this.editOrganCustomMode = false;
      } else if (type === "userorgan_name") {
        this.editProfileLabel = this.getDepartmentLabel();
        this.prepareOrganEditState();
      }
      this.editProfileVisible = true;
    },
    resetProfileEdit() {
      this.editProfileType = "name";
      this.editProfileLabel = "";
      this.editProfileVal = "";
      this.editOrganSelect = "";
      this.editOrganCustom = "";
      this.editOrganCustomMode = false;
      this.editProfileSubmitting = false;
    },
    onProfileDialogOpened() {
      this.$nextTick(() => {
        const input = this.$refs.profileEditInput;
        if (input && input.focus) {
          input.focus();
        }
      });
    },
    onOrganSelectChange(value) {
      this.editOrganCustomMode = value === "自定义";
      if (value !== "自定义") {
        this.editOrganCustom = "";
      } else {
        this.$nextTick(() => {
          const input = this.$refs.profileEditInput;
          if (input && input.focus) {
            input.focus();
          }
        });
      }
    },
    hasEmptyProfileField(obj, keys = Object.keys(obj)) {
      return keys.some(
        (key) =>
          Object.prototype.hasOwnProperty.call(obj, key) &&
          (obj[key] === "" || obj[key] == null)
      );
    },
    submitProfileEdit() {
      const payload = {
        request_type: "modify",
      };
      if (this.editProfileLabel === "姓名") {
        payload.new_name = String(this.editProfileVal || "").trim();
      } else if (
        this.editProfileLabel === "团队" ||
        this.editProfileLabel === "专业"
      ) {
        payload.group = String(this.editProfileVal || "").trim();
      } else if (
        this.editProfileLabel === "科室" ||
        this.editProfileLabel === "院系" ||
        this.editProfileLabel === "部门"
      ) {
        payload.organ_name = this.editOrganCustomMode
          ? String(this.editOrganCustom || "").trim()
          : String(this.editOrganSelect || "").trim();
      }
      if (this.hasEmptyProfileField(payload, Object.keys(payload))) {
        this.$message.warning(`${this.editProfileLabel}不能为空！`);
        return;
      }
      this.editProfileSubmitting = true;
      modifyUser(payload)
        .then((res) => {
          if (res.data.error_code == 0) {
            this.$message.success(res.data.msg || "保存成功");
            this.editProfileVisible = false;
            this.syncProfileInfo(payload);
            this.message();
          } else {
            this.$message.error(res.data.msg || "保存失败");
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.editProfileSubmitting = false;
        });
    },
    syncProfileInfo(payload) {
      if (payload.new_name) {
        this.name = payload.new_name;
      }
      if (payload.group) {
        this.group = payload.group;
      }
      if (payload.organ_name) {
        this.userOrganName = payload.organ_name;
      }
      const mesRaw = sessionStorage.getItem("mes");
      if (mesRaw) {
        const mes = JSON.parse(mesRaw);
        if (payload.new_name) {
          mes.name = payload.new_name;
        }
        if (payload.group) {
          mes.group = payload.group;
        }
        if (payload.organ_name) {
          mes.userorgan_name = payload.organ_name;
          mes.faculty = payload.organ_name;
        }
        sessionStorage.setItem("mes", JSON.stringify(mes));
        this.msg_copy = mes;
      }
    },
    openContactEdit(type) {
      this.clearEditCountdown();
      this.editContactType = type;
      this.editContactStep = type === "phone" ? 1 : 2;
      this.editNewVal = "";
      this.editCodeVal = "";
      this.editPhoneVerify = "";
      this.editPhoneVerifyFocus = false;
      this.editSendingCode = false;
      this.editContactVisible = true;
      if (type === "phone") {
        this.$nextTick(() => {
          this.focusPhoneVerifyInput();
        });
      }
    },
    resetContactEdit() {
      this.clearEditCountdown();
      this.editContactType = "phone";
      this.editContactStep = 1;
      this.editNewVal = "";
      this.editCodeVal = "";
      this.editPhoneVerify = "";
      this.editPhoneVerifyFocus = false;
      this.editSendingCode = false;
      this.editSubmitting = false;
    },
    focusPhoneVerifyInput() {
      const input = this.$refs.phoneVerifyInput;
      if (input) {
        input.focus();
      }
    },
    isPhoneVerifyBoxActive(index) {
      if (!this.editPhoneVerifyFocus) {
        return false;
      }
      const length = this.editPhoneVerify.length;
      if (length >= 4) {
        return index === 3;
      }
      return index === length;
    },
    onPhoneVerifyInput(event) {
      const value = String(event.target.value || "")
        .replace(/\D/g, "")
        .slice(0, 4);
      this.editPhoneVerify = value;
      event.target.value = value;
      if (value.length === 4) {
        this.$nextTick(() => {
          this.verifyPhoneStep();
        });
      }
    },
    verifyPhoneStep() {
      const verifyCode = String(this.editPhoneVerify || "").trim();
      if (verifyCode.length !== 4) {
        this.$message.warning("请补全手机号");
        return;
      }
      const realPhone = String(this.real_phone || "");
      const maskedPart = realPhone.substr(3, 4);
      if (!maskedPart) {
        this.enterContactStepTwo();
        return;
      }
      if (verifyCode !== maskedPart) {
        this.$message.error("验证失败，请修改重试");
        return;
      }
      this.$message.success("验证成功");
      this.enterContactStepTwo();
    },
    enterContactStepTwo() {
      this.clearEditCountdown();
      this.editNewVal = "";
      this.editCodeVal = "";
      this.editSendingCode = false;
      this.editContactStep = 2;
    },
    validateContactValue() {
      if (this.editContactType === "phone") {
        if (!/^1[3-9]\d{9}$/.test(this.editNewVal)) {
          this.$message.warning("手机号格式不正确");
          return false;
        }
      } else if (!/^[\w-.]+@[\w-]+\.[\w-.]+$/.test(this.editNewVal)) {
        this.$message.warning("邮箱格式不正确");
        return false;
      }
      return true;
    },
    sendContactCode() {
      if (!this.validateContactValue() || this.editCountdown > 0 || this.editSendingCode) {
        return;
      }
      this.editSendingCode = true;
      const request =
        this.editContactType === "phone"
          ? modifyUserSendCode({
              request_type: "modify",
              new_phone: this.editNewVal,
            })
          : emailRegister({
              new_email: this.editNewVal,
            });
      request
        .then((res) => {
          if (res.data.error_code == 0) {
            this.$message.success(res.data.msg || "验证码已发送");
            this.startEditCountdown();
          } else {
            this.$message.error(res.data.msg || "验证码发送失败");
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.editSendingCode = false;
        });
    },
    submitContactEdit() {
      if (!this.validateContactValue()) {
        return;
      }
      if (!this.editCodeVal) {
        this.$message.warning("请输入验证码");
        return;
      }
      const payload = {
        request_type: "modify",
        code: this.editCodeVal,
      };
      if (this.editContactType === "phone") {
        payload.new_phone = this.editNewVal;
      } else {
        payload.new_email = this.editNewVal;
      }
      this.editSubmitting = true;
      modifyUser(payload)
        .then((res) => {
          if (res.data.error_code == 0) {
            this.$message.success(res.data.msg || "绑定成功");
            this.editContactVisible = false;
            this.syncContactInfo(payload);
            this.message();
          } else {
            this.$message.error(res.data.msg || "绑定失败");
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.editSubmitting = false;
        });
    },
    syncContactInfo(payload) {
      if (payload.new_phone) {
        this.phone = payload.new_phone.replace(
          /^(\d{3})\d{4}(\d{4})$/,
          "$1xxxx$2"
        );
        this.real_phone = payload.new_phone;
      }
      if (payload.new_email) {
        this.email = payload.new_email;
      }
      const mesRaw = sessionStorage.getItem("mes");
      if (mesRaw) {
        const mes = JSON.parse(mesRaw);
        if (payload.new_phone) {
          mes.phone = this.phone;
          mes.real_phone = payload.new_phone;
        }
        if (payload.new_email) {
          mes.email = payload.new_email;
        }
        sessionStorage.setItem("mes", JSON.stringify(mes));
        this.msg_copy = mes;
      }
    },
    startEditCountdown() {
      this.clearEditCountdown();
      this.editCountdown = 60;
      this.editCountdownTimer = setInterval(() => {
        if (this.editCountdown <= 1) {
          this.clearEditCountdown();
        } else {
          this.editCountdown -= 1;
        }
      }, 1000);
    },
    clearEditCountdown() {
      if (this.editCountdownTimer) {
        clearInterval(this.editCountdownTimer);
        this.editCountdownTimer = null;
      }
      this.editCountdown = 0;
    },
  },
};
</script>

<style lang='less' scoped>
.headers {
  // margin: 20px;

  // background-color: #ffffff;
  // display: flex;
  // justify-content: center;
  // padding: 0 20px;
  // min-width: 986px;
  .my_header {
    // display: flex;
    // justify-content: center;
    // min-width: 880px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    .message {
      // min-width: 450px;
      // width: 45%;
      // margin-right: 20px;
      display: flex;
      padding: 18px 16px;
      flex-direction: column;
      align-self: stretch;
      align-items: flex-start;
      width: 100%;
      border-radius: 8px;
      background: #fff;
      .literatureInfo {
        width: 100%;
        :nth-child(1) {
          // font-weight: 600;
          color: var(--Gray-Gray-500, #a1a5b7);
          font-weight: 500;
        }
      }
      img {
        margin: 20px;
        width: 120px;
        // width: 40%;
        // max-width: 120px;
        height: 120px;
        border-radius: 60px;
      }

      .meaasge_box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 14px;
        flex: 1 0 0;
        min-width: 0;
        .box_tit {
          color: var(---, #8d8f94);
          font-weight: 500;
          line-height: 20px;
          width: 100%;
        }
        .meaasge_box_grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          column-gap: 48px;
          row-gap: 14px;
          width: 100%;
        }
        .box_li {
          display: flex;
          min-height: 32px;
          align-items: center;
          width: 100%;
          min-width: 0;
          .box_li_left {
            width: 72px;
            flex-shrink: 0;
            color: var(--Gray-500, #79716b);
          }
          .box_li_right {
            flex: 1;
            min-width: 0;
            color: var(--Gray-Gray-800, #3f4254);
          }
          .box_li_right--status {
            display: flex;
            align-items: center;
            gap: 8px;
            flex-wrap: wrap;
          }
        }
        .status-badge {
          width: 120px;
          height: 27px;
          margin: 0;
          border-radius: 0;
        }
        .org-badge {
          width: 45px;
          height: 21px;
          margin: 0;
          border-radius: 0;
        }
        .box_li--editable {
          cursor: pointer;
          .box_li_right--action {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 8px;
            flex-wrap: wrap;
          }
          &:hover {
            .contact-arrow {
              color: #e2426b;
            }
          }
        }
        .contact-unbound {
          color: #a1a1aa;
        }
        .contact-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #f04438;
          flex-shrink: 0;
        }
        .contact-arrow {
          color: #c0c4cc;
          font-size: 14px;
        }
        .accountType {
          // background-color: #74d8ca;
          // color: #fff;
          // border-radius: 0;
          display: flex;
          padding: 5px 10px;
          justify-content: center;
          align-items: center;
          gap: 4px;
          border-radius: 4px;
          background: #e2426b;
          color: var(---Color-7, #fff);
          font-size: 10px;
        }
        .tag {
          display: flex;
          align-items: center;
          span {
            // display: inline-block;
          }
          .name {
            font-size: 16px;
            font-weight: 600;
            min-width: 48px;
            margin: 0 10px 0 0;
            max-width: 140px;
            overflow: hidden;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }

          .groupName {
            background-color: #72b3d9;
            color: #fff;
            margin: 0 10px;
            // border-radius: 0;
            span {
              display: inline-block;
              width: 60px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }
        }
        div {
          // margin: 10px 0;
        }
      }
    }
  }
}
.tit_h2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    color: #e2426b;
    font-size: 16px;
    cursor: pointer;
  }
}
.table_type {
  color: var(--Gray-Gray-800, #3f4254) !important;
}
.textCer_css {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: #fd6273;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>

<style lang="less">
.contact-edit-dialog {
  .contact-edit-step {
    padding-top: 4px;
  }
  .contact-edit-desc {
    margin: 0 0 20px;
    line-height: 24px;
    color: #3f4254;
  }
  .contact-edit-muted {
    color: #a1a1aa;
  }
  .phone-verify-code-wrap {
    position: relative;
    padding: 20px 30px 8px;
    display: flex;
    justify-content: center;
  }
  .phone-verify-code-container {
    display: flex;
    justify-content: center;
    gap: 12px;
  }
  .phone-verify-code-box {
    flex: 0 0 50px;
    width: 50px;
    height: 50px;
    border: 1px solid #dcdfe6;
    background: #fff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 500;
    color: #27272a;
    box-sizing: border-box;
    cursor: text;
    transition: border-color 0.2s ease;
  }
  .phone-verify-code-box.is-active {
    border-color: #e2426b;
  }
  .phone-verify-hidden-input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
    border: 0;
    outline: none;
  }
  .el-input-group__append .el-button {
    background: #e2426b;
    border-color: #e2426b;
    color: #fff;
  }
  .el-input-group__append .el-button.is-disabled {
    background: #f1f2f2;
    border-color: #f1f2f2;
    color: #a1a1aa;
  }
  .el-dialog__footer {
    padding: 0;
  }
}

.profile-edit-dialog,
.contact-edit-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    padding: 16px 20px 0;
    border-bottom: none;
  }
  .el-dialog__title {
    font-size: 16px;
    font-weight: 500;
    color: #27272a;
  }
  .el-dialog__headerbtn {
    top: 16px;
    right: 16px;
  }
  .el-dialog__body {
    padding: 0 32px 28px;
  }
  .el-dialog__footer {
    padding: 0;
    border-top: 1px solid #eeeff0;
  }

  .profile-edit-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    padding-top: 4px;
  }
  .profile-edit-title {
    color: #000;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
  }
  .profile-edit-form {
    width: 100%;
  }
  .profile-edit-field {
    width: 100%;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    .el-form-item__content {
      line-height: normal;
    }
    .el-input,
    .el-select {
      width: 100%;
    }
    .el-input__inner {
      height: 46px;
      line-height: 46px;
      border: none;
      border-radius: 100px;
      background: #f5f5f5;
      padding: 0 24px;
      color: #27272a;
      transition: background-color 0.2s ease;

      &:focus {
        background: #efefef;
      }
    }
    .el-input__inner::placeholder {
      color: #a1a1aa;
    }
    .el-select .el-input__inner {
      cursor: pointer;
    }
    .el-input-group__append {
      border: none;
      background: transparent;
      padding-right: 6px;
    }
    .el-input-group--append .el-input__inner {
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
    }
    .el-input-group__append .el-button {
      height: 34px;
      padding: 0 16px;
      border-radius: 100px;
      font-size: 13px;
    }
  }

  .contact-code-row {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
  }
  .contact-code-input {
    flex: 1;
    min-width: 0;
  }
  .contact-code-btn {
    flex-shrink: 0;
    min-width: 108px;
    height: 46px !important;
    padding: 0 16px !important;
    border: none !important;
    border-radius: 100px !important;
    background: #e2426b !important;
    color: #fff !important;
    font-size: 13px;
    line-height: 46px;
    &.is-disabled {
      background: #f1f2f2 !important;
      color: #a1a1aa !important;
    }
  }
  .profile-edit-field--code {
    margin-bottom: 0;
  }

  .profile-edit-footer {
    display: flex;
    height: 53px;
    width: 100%;
  }
  .profile-edit-btn {
    flex: 1;
    border: none;
    background: #fff;
    font-size: 16px;
    cursor: pointer;
    outline: none;
    transition: background-color 0.2s ease;

    &:hover:not(:disabled) {
      background: #fafafa;
    }
    &--cancel {
      color: #a1a1aa;
      border-right: 1px solid #f4f4f5;
    }
    &--confirm {
      color: #e2426b;
      font-weight: 500;
    }
    &:disabled {
      opacity: 0.55;
      cursor: not-allowed;
    }
  }
}

.profile-edit-dialog {
  .el-dialog__header {
    padding: 12px 16px 0;
  }
  .el-dialog__title {
    display: none;
  }
}
</style>